import {
  GET_PRODUCTS_QUERY,
  GET_REFILL_COLLECTION,
  GET_PREFILL_COLLECTION,
} from "./queries.js";

export const fetchProductsByFilters = async ({endpoint, token, variables}) => {
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": token,
    },
    body: JSON.stringify({
      query: GET_PRODUCTS_QUERY,
      variables,
    }),
  });

  const data = await response.json();

  return (
    data?.data?.products?.edges?.map((p) => {
      const tags = p?.node?.tags || [];
      const collections = p?.node?.collections?.nodes || [];

      const profiles = tags.filter((tag) => tag.startsWith("Profile:"));

      return {
        id: p?.node?.id,
        handle: p?.node?.handle,
        title: p?.node?.title,
        vendor: p?.node?.vendor,
        productType: p?.node?.productType,
        img: p?.node?.featuredImage?.url,
        quantity: p?.node?.totalInventory,
        tags,
        collections,
        prices: {
          max: p?.node?.priceRange?.maxVariantPrice?.amount,
          min: p?.node?.priceRange?.minVariantPrice?.amount,
        },
        profiles,
      };
    }) || []
  );
};

export const fetchRefillCollection = async ({endpoint, token}) => {
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": token,
    },
    body: JSON.stringify({
      query: GET_REFILL_COLLECTION,
    }),
  });

  const data = await response.json();
  const products = data?.data?.collectionByHandle?.products?.nodes;

  return products;
};

export const fetchPrefillCollection = async ({endpoint, token}) => {
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": token,
    },
    body: JSON.stringify({
      query: GET_PREFILL_COLLECTION,
    }),
  });

  const data = await response.json();
  const products = data?.data?.collectionByHandle?.products?.nodes;

  return products;
};
